export default "__VITE_ASSET__CVNVOQV3__"